<template>
  <div class="user_list_page">
    <pageTitle />
    <business-group
      ref="businessGroup"
      :tableConfig="{ ...tableConfig }"
      :formConfig="{ ...formConfig }"
    >
      <!-- <template #conflictReason="conflictReason">
        <a-tooltip >
          <template slot="title">
            {{ conflictReason.conflictReason || '暂无'  }}
          </template>
          <a-icon type="question-circle" theme="twoTone" />
        </a-tooltip>
      </template> -->
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input
            placeholder="请输入效果名称/上传者"
            v-decorator="['keyword']"
            style="width: 200px; margin-right: 10px; vertical-align: middle"
          />
        </a-form-item>
        <a-form-item>
          <a-select v-decorator="['lightType']" placeholder="请选择效果类型" style="width: 150px">
            <a-select-option v-for="el in lightType" :key="el.value" :value="el.value">{{
              el.label
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-form-item>
          <a-select v-decorator="['checkStatus']" placeholder="请选择状态" style="width:150px">
            <a-select-option v-for="el in checkStatusSelect" :key="el.value" :value="el.value">{{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
      </template>
      <template slot="lightType" slot-scope="record">
        <span v-text="createMaps(lightType, record.lightType)" />
      </template>
      <template slot="effectType" slot-scope="record">
        <m-image v-if="record.effectType === 'PICTURE'" :url="record.effectUrl" />
        <mVideo
          v-if="record.effectType === 'VIDEO'"
          :img-url="record.videoCover"
          :video-url="record.effectUrl"
        />
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="() => del(record)">删除</a-button>
      </template>
      <template slot="avatar" slot-scope="record">
        <viewer :images="[record.avatar]">
          <a-avatar size="large" :src="record.avatar" />
        </viewer>
      </template>
      <template slot="lightEffect" slot-scope="record">
        <div v-if="record.lightType === 'WHITE_LIGHT'">
          <p>亮度: {{ record.brightness || 0 }} %</p>
          <p>色温: {{ record.colorTemperature || 0 }} K</p>
          <!--          <p>GM: {{ record.gm }}</p>-->
          <div v-if="record.lightEffect === 'COLOR_TEMPERATURE_PIECE'">
            <p>CTO: {{ record.cto || 0 }} CTO</p>
            <p>CTB: {{ record.ctb || 0 }} CTB</p>
          </div>
        </div>
        <!--   彩光    -->
        <div v-if="record.lightType === 'COLORAMA'">
          <p>亮度: {{ record.brightness || 0 }} %</p>
          <p>CTB: {{ record.ctb || 0 }} CTB</p>
          <!--          <p>HSI亮度: {{ record.intensity }}</p>-->
          <!--          <p>HSI饱和度: {{ record.saturation }}</p>-->
          <!--          <p>HSI色调: {{ record.hue }}</p>-->
          <!--          <div v-if="record.lightEffect === 'RGB'">-->
          <!--            <p>RGB: {{ record.RGB }}</p>-->
          <!--          </div>-->
          <div v-if="record.lightEffect === 'COLOR_COORDINATE'">
            <p>色坐标: {{ record.xtAxis }} {{ record.ytAxis }}</p>
          </div>
        </div>
        <!--   光效     -->
        <div v-if="record.lightType === 'LIGHT_EFFECT'">
          <p>亮度: {{ record.brightness || 0 }} %</p>
          <p>色相: {{ record.hue || 0 }} °</p>
          <p>饱和: {{ record.saturation || 0 }} %</p>
          <p>CTB: {{ record.intensity || 0 }} CTB</p>
        </div>
      </template>
      <!--          -->
    </business-group>
    <a-modal
      :visible="visibleChange"
      @ok="handleOk"
      @cancel="handleCancel"
      title="删除理由"
      style="margin-bottom: 10px"
      :maskClosable="false"
    >
      <a-textarea
        v-model="ly"
        :rows="8"
        :auto-size="{ minRows: 3, maxRows: 5 }"
        placeholder="请填写删除该条的理由"
      />
      <span class="modal-tips"
        ><a-icon type="exclamation-circle" /> 用户会通过消息中心接收到已被移除精选广场</span
      >
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";

import pageTitle from "@/components/business/pageTitle";
import myForm from "@/components/business/Form/myForm";
import myTable from "@/components/business/Table/myTable";
import mImage from "@/components/business/mImage/mImage";
import mVideo from "@/components/business/mVideo/mVideo";
import businessGroup from "@/components/business/businessGroup";
import { tips } from "@/utils/util";
// lightTypeFilterText
import { checkStatusSelect, lightType } from "@/utils/pageMaps";

const initial = {
  pageSize: 10,
  current: 1,
};
export default {
  components: {
    myForm,
    myTable,
    mImage,
    mVideo,
    pageTitle,
    businessGroup,
  },
  data() {
    return {
      dateFormat: this.$root.$data.dateFormat,
      query: {
        keyword: undefined, //搜索关键词：用户昵称、手机号码、邮箱
        startDate: undefined, // 否 开始日期，格式yyyy-MM-dd
        endDate: undefined, // 否结束日期，格式yyyy-MM-dd
        jobId: undefined, // 否 职业ID
        accountStatus: undefined, //否  账户状态，可选值：ENABLED（已启用）、DISABLED（已禁用）
      },
      tableConfig: {
        columns: [
          // {
          //   title: "",
          //   dataIndex: "conflictReason",
          //   key: "conflictReason",
          //   align: "center",
          //   width: 50,
          //   scopedSlots: { customRender: "conflictReason" },
          // },
          {
            title: "类型",
            dataIndex: "lightType",
            key: "lightType",
            align: "center",
            scopedSlots: { customRender: "lightType" },
          },
          {
            title: "效果名称",
            dataIndex: "effectName",
            key: "effectName",
            align: "center",
            // scopedSlots: { customRender: "effectName" }
          },
          {
            title: "效果描述",
            dataIndex: "effectDesc",
            key: "effectDesc",
            align: "center",
            // scopedSlots: { customRender: "effectDesc" }
          },
          {
            title: "效果图片/视频",
            dataIndex: "effectType",
            key: "effectType",
            align: "center",
            width: 150,
            scopedSlots: { customRender: "effectType" },
          },
          {
            title: "参数",
            dataIndex: "lightEffect",
            key: "lightEffect",
            align: "center",
            scopedSlots: { customRender: "lightEffect" },
          },
          {
            title: "头像",
            dataIndex: "avatar",
            key: "avatar",
            align: "center",
            scopedSlots: { customRender: "avatar" },
          },
          {
            title: "上传者",
            dataIndex: "nickname",
            key: "nickname",
            align: "center",
            // scopedSlots: { customRender: "nickname" }
          },
          {
            title: "上传时间",
            dataIndex: "createTime",
            key: "createTime",
            align: "center",
          },
          {
            title: "引用次数",
            dataIndex: "collectNum",
            key: "collectNum",
            align: "center",
          },
          {
            title: "操作",
            width: "180px",
            scopedSlots: { customRender: "action" },
            align: "center",
          },
        ],
        rowKey: "shareId",
        loading: false,
        url: "bluetoothlight/web/effect/lightshares?checkStatus=PASS",
      },
      formConfig: {
        timeShow: true,
        formShow: true,
      },
      dataUrl: "bluetoothlight/web/effect/lightshares?checkStatus=PASS",
      lightEffectSelect: [],

      lightType,
      checkStatusSelect,
      loading: false,
      visible: false,
      ly: undefined,
    };
  },
  created() {
    // this.getData();
    this.lightEffectMaps();
  },
  methods: {
    moment,
    // lightTypeFilterText,
    lightEffectMaps(code) {
      const maps = {
        COLOR_TEMPERATURE: "色温",
        LIGHT_SOURCE_LIBRARY: "光源库",
        LIGHT_SOURCE_MATCH: "光源匹配",
        COLOURED_PAPER: "色纸",
        HSI: "HSI",
        RGB: "RGB",
        COLOR_COORDINATE: "色坐标",
        COLOR_PICKER: "拾色器",
        SYSTEM: "系统",
        MANUAL: "专业手动",
        COLOR_EFFECT_PICKER: "光效拾取",
      };
      if (!this.lightEffectSelect.length) {
        this.lightEffectSelect = Object.keys(maps).map((el) => {
          return { value: el, label: maps[el] };
        });
      }
      return maps[code];
    },
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },
    handleSubmit(values) {
      if (this.loading) return false;
      this.loading = true;
      this.query = {
        ...this.query,
        ...values,
      };
      // this.getData();
      this.refreshData();

      this.loading = false;
    },
    getData: async function () {
      const { current, pageSize } = this.tableConfig.pagination || initial;
      this.tableConfig.loading = true;
      const res = await this.$get(this.dataUrl, {
        ...this.query,
        pageNo: current,
        pageSize: pageSize,
      });
      const resultData = res?.resultData;
      this.tableConfig.dataSource = resultData?.records || [];
      if (resultData) {
        // this.tableConfig.dataSource = resultData?.records;
        // this.$previewRefresh();
        // this.setPagination(initial);
      }
      this.tableConfig.loading = false;
    },
    handleTableChange(pagination = {}) {
      const { current, pageSize } = pagination;
      this.setPagination({ current, pageSize });
      // this.getData();
      this.refreshData();
    },
    setPagination(ops = {}) {
      const { pagination } = this.tableConfig;
      this.tableConfig.pagination = { ...pagination, ...ops };
    },
    del: async function (record) {
      const { shareId } = record;
      if (!shareId) return false;
      this.visible = true;
      this.shareId = shareId;
    },
    handleOk: async function () {
      if (!this.ly || this.loading) {
        tips(this, false, "请填写删除理由");
        return false;
      }
      this.loading = true;
      const res = await this.$http(
        "delete",
        `bluetoothlight/web/effect/lightshares/${this.shareId}`,
        {
          deleteReason: this.ly,
        }
      );
      const status = res?.resultStatus;
      tips(this, status);
      if (status) {
        this.visible = false;
        // await this.getData();
        await this.refreshData();
      }
      this.loading = false;
    },
    handleCancel() {
      this.visible = false;
    },
    createMaps(data, code) {
      return (
        data.reduce((acc, cur) => {
          const { label, value } = cur;
          acc[value] = label;
          return acc;
        }, {})[code] || ""
      );
    },
  },
  computed: {
    visibleChange() {
      if (!this.visible) {
        this.loading = false;
        this.ly = undefined;
        this.shareId = undefined;
      }
      return this.visible;
    },
  },
};
</script>


<style lang="less" scoped>
.user_list_page {
  .header {
    height: 50px;
    font-size: 24px;
    font-weight: 500;
    border-bottom: 1px solid #eee;
    margin-left: 5px;
  }

  .list_button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: none;
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    margin-right: 10px;
  }
}

.modal-tips {
  color: #999;
  margin-top: 10px;
  display: inline-block;
}
</style>
